import { Card, Row, Col } from "antd";
import { fetchBlogrollsCategories } from "~/redux/actions/app";

import SiteLayout from "~/components/layout/SiteLayout";

const Page = (props) => {
  const ColItem = (props) => {
    const { item } = props;
    return (
      <Col className="col" xl={6} lg={8} md={12} sm={12} xs={14}>
        <a href={item.url} target="_blank" className="link">
          {item.icon_url && (
            <img
              width="16"
              height="16"
              className="icon-img"
              src={item.icon_url}
              alt={item.name}
            />
          )}
          {item.name}
        </a>
      </Col>
    );
  };

  return (
    <SiteLayout pageTitle="发现">
      {props.blogrollCategories.map((item1) => (
        <Card key={item1.id}>
          <div className="links-label">{item1.name}</div>
          <Row>
            {item1.blogrolls.map((item2) => (
              <ColItem key={item2.id} item={item2} />
            ))}
          </Row>
        </Card>
      ))}

      <div className="add-notice">
        <p>如需添加站点，请发邮件联系：eleduck@qq.com</p>
        {/* <img width="250" src="/static/WechatIMG99.jpg" /> */}
      </div>
    </SiteLayout>
  );
};

Page.getInitialProps = async (ctx) => {
  let blogrollCategories = [];
  try {
    blogrollCategories = await fetchBlogrollsCategories();
    blogrollCategories = blogrollCategories.filter((item) => item.id !== 1);
  } catch (error) {
    ctx.res.statusCode = error.statusCode;
  }
  return {
    blogrollCategories,
  };
};

export default Page;
